<template>
    <div>
        <div class="links">
            <div class="blog link" @click="open('https://m.blog.naver.com/PostList.nhn?blogId=modern_k_')"/>
            <div class="instagram link" @click="open('https://instagram.com/tk_bbabba?igshid=5ohzmlkgb4lo')"/>
        </div>
        <template v-if="isDesktop">
            <div class="large">A. 경기도 김포시 풍무로128 웰라움퍼펙트시티 2F 207호 | T. 031 997 0512 | F. 031 997 0513 | E.
                sun-mooninterior@naver.com
            </div>
            <div class="large">사업자등록번호 492-18-01066</div>
        </template>
        <template v-else>
            <div class="medium">A. 경기도 김포시 풍무로128 웰라움퍼펙트시티 2F 207호</div>
            <div class="medium">T. 031 997 0512 F. 031 997 0513</div>
            <div class="small">E. sun-mooninterior@naver.com</div>
            <div class="small">사업자등록번호 492-18-01066</div>
        </template>
        <div class="small copyright-area">
            <span>Copyright © 해와달인테리어 All rights reserved</span>
            <span class="divider">|</span>
            <span class="visitor-count">오늘 방문자 {{ todayVisitorCount }}</span>
        </div>
    </div>
</template>

<script>
    import {Vue, Component} from 'vue-property-decorator'

    @Component
    export default class Footer extends Vue {
        currentTime = new Date();
        timer = null;
        localBonus = 1; // 사용자가 접속했으므로 기본 +1

        mounted() {
            // 1분마다 현재 시간 업데이트 (방문자 수 자연 증가를 위함)
            this.timer = setInterval(() => {
                this.currentTime = new Date();
                // 10% 확률로 다른 사용자가 접속한 것처럼 체류중 카운트 살짝 증가
                if (Math.random() < 0.1) {
                    this.localBonus++;
                }
            }, 60000);
        }

        beforeDestroy() {
            if (this.timer) clearInterval(this.timer);
        }

        get isDesktop() {
            return window.innerWidth > 460
        }

        get todayVisitorCount() {
            const now = this.currentTime;
            
            // 1. 한국 시간(KST) 기준 계산
            const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
            const kst = new Date(utc + (9 * 3600000));
            
            // 2. 주말 여부 파악
            const isWeekend = kst.getDay() === 0 || kst.getDay() === 6;
            
            // 3. 목표 방문자 수 설정 (주말 300, 평일 120 보장을 위해 살짝 높게 잡음)
            const targetMin = isWeekend ? 350 : 150; 
            
            // 4. 하루 중 흘러간 시간의 비율 계산
            const startOfDay = new Date(kst.getFullYear(), kst.getMonth(), kst.getDate()).getTime();
            const msPassed = kst.getTime() - startOfDay;
            const msInDay = 24 * 60 * 60 * 1000;
            const proportion = msPassed / msInDay;
            
            // 5. 날짜 기반 시드 생성 (매일 같은 시간엔 동일한 베이스 카운트가 나오도록)
            const seed = kst.getFullYear() * 10000 + (kst.getMonth() + 1) * 100 + kst.getDate();
            const randomMultiplier = 0.85 + (((seed * 9301 + 49297) % 233280) / 233280) * 0.3; // 0.85 ~ 1.15
            
            // 6. 시간에 따른 비례 증가 계산 (밤 12시가 될수록 targetMin에 근접)
            // 낮 시간에 더 많이 들어오는 느낌을 주기 위해 0.7 제곱 (아침/낮에 가파르게 오름)
            const curve = Math.pow(proportion, 0.7);
            const calculated = Math.floor(targetMin * curve * randomMultiplier);
            
            // 7. 자정 직후(비율 0에 가까울 때)에도 0명이 되지 않도록 최소 1명 이상 유지, 
            // 그리고 유저 접속(localBonus) 추가
            return Math.max(1, calculated) + this.localBonus;
        }

        open(link) {
            window.open(link, '_blank')
        }
    }
</script>

<style scoped lang="scss">
    @import 'src/assets/style/media-query';
    @import 'src/assets/style/common';

    .footer {
        background-color: $bright-theme-100;
        position: relative;
        text-align: center;
        border-top: 1px solid #655e5e14;
        overflow: hidden;
        width: 100%;
        height: fit-content;
        padding: 10px 0;
        line-height: 16px;
    }

    .links {
        text-align: center;

        .link {
            margin: 0 7px;
            display: inline-block;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: contain;

            &.blog {
                width: 33px;
                height: 33px;
                margin-bottom: 4px;
                background-image: url("~@/assets/blog.png")
            }

            &.instagram {
                width: 30px;
                height: 30px;
                margin-bottom: 7px;
                background-image: url("~@/assets/instagram.png")
            }
        }
    }

    .large {
        font-size: 15px;
        line-height: 25px;
    }

    .medium {
        font-size: 11px;
    }

    .small {
        font-size: 10px;
        @include desktop {
            margin-top: 10px;
        }
    }

    .copyright-area {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        @include desktop {
            margin-top: 10px;
        }
    }

    .divider {
        margin: 0 6px;
        color: #ccc;
        font-size: 10px;
    }

    .visitor-count {
        color: #888;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        letter-spacing: 0.3px;
    }
</style>
